/**
 * Where a book lives, stated once for the two sides that have to agree.
 *
 * The API writes an address into a mail and the web resolves it, and they are
 * built and deployed apart: an address the API wrote that the web has no route
 * for lands on the shelf's fallback with nothing on either side failing. So the
 * templates are here, the API composes an address from them, and the web mounts
 * its routes on them — one spelling, which a test then resolves.
 *
 * A template is written the way the router reads one, with `$id` standing for
 * the book.
 */
export const BOOKS_PATH = '/books'
export const BOOK_PATH = '/books/$id'

/**
 * A book's address that mail already sent carries.
 *
 * Mail cannot be recalled, so an address already sent is one somebody will
 * open: it sends the reader to the book's address above. It sits under
 * All documents, whose own views are named segments, so a book's id is the
 * only thing left for it to match.
 */
export const MOVED_BOOK_PATH = '/documents/$id'

/** A view of the band a book can be opened with beside it. */
export type BookBeside = 'history'

/**
 * One book's address, and what to open beside it on arrival.
 *
 * A rollup names `history`, because a summary raises "what exactly happened"
 * and the top of the book does not answer it.
 */
export function bookAddress(id: string, beside?: BookBeside): string {
  const path = BOOK_PATH.replace('$id', encodeURIComponent(id))
  return beside ? `${path}?beside=${beside}` : path
}

/** The shelf, opened on what has been offered to the reader. */
export function offersAddress(): string {
  return `${BOOKS_PATH}?offers=1`
}
